/** Shared room calendar palette (create/edit room + calendar sidebar). Exactly 10. */
export const ROOM_CALENDAR_COLOR_OPTIONS = [
  { key: 'czerwony', color: '#E53935' },
  { key: 'pomaranczowy', color: '#FB8C00' },
  { key: 'zolty', color: '#F9A825' },
  { key: 'zielony', color: '#43A047' },
  { key: 'turkusowy', color: '#00897B' },
  { key: 'niebieski', color: '#1E88E5' },
  { key: 'granatowy', color: '#3949AB' },
  { key: 'fioletowy', color: '#8E24AA' },
  { key: 'rozowy', color: '#D81B60' },
  { key: 'szary', color: '#607D8B' },
] as const;

export const ROOM_CALENDAR_COLORS = ROOM_CALENDAR_COLOR_OPTIONS.map((option) => option.color);

export type RoomCalendarColorOption = (typeof ROOM_CALENDAR_COLOR_OPTIONS)[number];
